'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIDEOTYPE = exports.VIDEOTYPE = 'draft-js-video-plugin-video';
var ATOMIC = exports.ATOMIC = 'atomic';